import { useState, useEffect } from "react";
import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  isEdit?: boolean;
  editData?: { question: string; answer: string; question_ar?: string; answer_ar?: string } | null;
  onSubmit?: (question: string, answer: string, questionAr: string, answerAr: string) => void;
  loading?: boolean;
}

export default function AddFaq({
  open,
  onClose,
  setOpen,
  isEdit = false,
  editData,
  onSubmit,
  loading = false,
}: ModalProps) {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [questionAr, setQuestionAr] = useState("");
  const [answerAr, setAnswerAr] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(false);
    if (open && isEdit && editData) {
      setQuestion(editData.question);
      setAnswer(editData.answer);
      setQuestionAr(editData.question_ar || "");
      setAnswerAr(editData.answer_ar || "");
    } else if (open && !isEdit) {
      setQuestion("");
      setAnswer("");
      setQuestionAr("");
      setAnswerAr("");
    }
  }, [open, isEdit, editData]);

  return (
    <Modal
      className="modal addNotification_modal"
      open={open}
      onClose={() => {
        onClose();
        setError(false);
      }}
    >
      <div className="modal-dialog" style={{ maxWidth: 700, width: "100%" }}>
        <div className="modal-body">
          <div className="modal_title">
            <h2 style={{ whiteSpace: "nowrap" }}>{isEdit ? "Edit FAQ" : "Add new FAQ"}</h2>

            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>

          <form className="form">
            {/* Question row */}
            <div style={{ display: "flex", gap: 16 }}>
              <div className="control_group" style={{ flex: 1 }}>
                <label>Question</label>
                <TextField
                  placeholder="Enter Question"
                  fullWidth
                  value={question}
                  onChange={(e) => setQuestion(e.target.value)}
                  hiddenLabel
                />
                {error && !question.trim() && (
                  <h6 className="err_msg">Question is required</h6>
                )}
              </div>
              <div className="control_group" style={{ flex: 1 }}>
                <label>سؤال</label>
                <TextField
                  placeholder="أدخل السؤال"
                  fullWidth
                  value={questionAr}
                  onChange={(e) => setQuestionAr(e.target.value)}
                  hiddenLabel
                />
              </div>
            </div>

            {/* Answer row */}
            <div style={{ display: "flex", gap: 16 }}>
              <div className="control_group" style={{ flex: 1 }}>
                <label>Answer</label>
                <TextField
                  placeholder="Enter Answer"
                  fullWidth
                  hiddenLabel
                  multiline
                  value={answer}
                  onChange={(e) => setAnswer(e.target.value)}
                  maxRows={5}
                  minRows={5}
                />
                {error && !answer.trim() && (
                  <h6 className="err_msg">Answer is required</h6>
                )}
              </div>
              <div className="control_group" style={{ flex: 1 }}>
                <label>إجابة</label>
                <TextField
                  placeholder="أدخل السؤال"
                  fullWidth
                  hiddenLabel
                  multiline
                  value={answerAr}
                  onChange={(e) => setAnswerAr(e.target.value)}
                  maxRows={5}
                  minRows={5}
                />
              </div>
            </div>

            <div className="footer_btn_flex">
              <Button
                className="btn btn_grey"
                onClick={() => {
                  setError(false);
                  setOpen(false);
                }}
              >
                Cancel
              </Button>

              <Button
                className="btn btn_primary"
                disabled={loading}
                onClick={() => {
                  if (!question.trim() || !answer.trim()) {
                    setError(true);
                    return;
                  }
                  if (onSubmit) {
                    onSubmit(question, answer, questionAr, answerAr);
                  } else {
                    setOpen(false);
                  }
                }}
              >
                {loading
                  ? isEdit
                    ? "Updating..."
                    : "Submitting..."
                  : isEdit
                    ? "Update"
                    : "Save"}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
